export const blockIconsAudioandvideoVolumeOffNew = (
	<span className='material-symbols-outlined'>volume_off</span>
);
